// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2292":"f65e746b","3065":"f65e746b","4332":"f65e746b","5615":"f65e746b","6500":"f65e746b"}[chunkId] + ".chunk.css";
};